module.exports = __webpack_public_path__ + "img/cover.323f7681.png";